<template>
  <section id="sobre">
    <div class="center-container">
      <div class="title">
        <h2>Quem somos?</h2>
        <h3>Sobre a Pousada Recanto da Família</h3>
        <div class="decoration">
          <div class="dotted-border"></div>
          <i class="fab fa-pagelines"></i>
          <div class="dotted-border"></div>
        </div>
      </div>
      <div class="content">
        <div class="text">
            <p>
              A <strong>Pousada Recanto da Família</strong> nasceu do sonho de um casal de São Bernardo do Campo que, nos passeios de finais de semana, conheceram e se encantaram com o circuito <em>“Entre Serras e Águas”</em>. Suas viagens de lazer sempre tinham destino certo: <strong>Bragança Paulista</strong>.
            </p>
            <p>
              Quando chegou a aposentadoria, eles decidiram mudar para essa cidade. Foram morar num sítio, onde antigamente funcionava um olaria. O projeto inicial era apenas construir um pesqueiro. Do lugar onde se extraía o barro para os tijolos, eles formaram os lagos.
            </p>
            <p>
              Começaram a criar diferentes espécies de peixes. E plantaram inúmeras mudas de árvores nativas, que foram crescendo junto com uma nova idéia: a de montar uma pousada. Depois de alguns anos de trabalho, o sonho tornou-se realidade. Em 2006, foi inaugurada a almejada pousada.
            </p>
        </div>
        <div class="images">
          <img src="../assets/img/old_photo.jpg" class="old-photo" alt="Foto Antiga">
          <img src="../assets/img/new_photo.jpg" class="new-photo" alt="Foto Nova">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'About'
}
</script>
